import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { UnsavedChangesService } from '../services/unsaved-changes.service';

/**
 * Уход со страницы должника и смена должника (`debtors/:id`) при несохранённых правках (S5 Д-13).
 * Смену вкладки (`:tab`) спрашивает `changeTab` страницы — guard родителя на неё не срабатывает.
 */
export const unsavedChangesGuard: CanDeactivateFn<unknown> = () => inject(UnsavedChangesService).confirmLeave();
